import Vue from 'vue';
import PortalVue from 'portal-vue';
import { InertiaProgress } from '@inertiajs/progress';
import { createInertiaApp } from '@inertiajs/inertia-vue';


import ElementUI from './Plugins/element-ui';
import LineAwesome from 'line-awesome/dist/line-awesome/css/line-awesome.css';
import axios from './Plugins/axios';
import moment from './Plugins/moment';
import image from './Plugins/image-compress';
import global from '@/Plugins/global';
import pdf from '@/Plugins/pdf';
import pdfmake from '@/Plugins/pdfmaker';
import {createStore} from './Store/index';

Vue.config.productionTip = false;

InertiaProgress.init({
    color: '#4da499'
});


/*
const resolveComponent = (name) => {
    const nameSegment = name.split('/')[0];
    console.log(nameSegment)
    if (nameSegment === 'Components') {
        // Check other locations for components (e.g., "Components" folder)
        console.log(1234)
        return Promise.resolve(require(`./Components//${name}`).default);
    }
    // Default to looking in the "Pages" folder
    return Promise.resolve(require(`./Pages/${name}`).default);

};
*/

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    // resolve: resolveComponent,
    title: title => title ? `${title} - PPI` : 'PPI',
    setup({ el, app, props, plugin }) {
        Vue.use(plugin)
        Vue.use(PortalVue)
        Vue.use(moment)
        Vue.use(image)
        Vue.use(ElementUI)
        Vue.use(LineAwesome)
        Vue.use(pdf)
        Vue.use(pdfmake)
        Vue.use(axios, {token: ''})
        Vue.use(global);

        const store = createStore();
        new Vue({
            store,
            render: h => h(app, props)
        }).$mount(el)
    },
})
